module.exports = __webpack_public_path__ + "static/brand7-b713491273d6e60da67dbc4459a967aa.png";